/**
 * Copyright (C) Firstlight Media. All rights reserved.
 * All information contained herein is and remains the property of Firstlight Media.
 * The intellectual and technical concepts contained herein are proprietary
 * to Firstlight Media. Dissemination of this information or reproduction
 * of this material is strictly forbidden unless prior written permission
 * is obtained from Firstlight Media.
 */

/**
 * Represents a unique identifier for the platform.
 */
export enum PlatformName {
  IOS = 'iOS',
  ANDROID_MOBILE = 'Android Mobile',
  TV_OS = 'tvOS',
  ANDROID_TV = 'Android TV',
  FIRE_TV = 'Fire TV',
  LG = 'LG',
  CHROMECAST = 'Chromecast',
  WEB_DESKTOP = 'Web Desktop',
  WEB_MOBILE = 'Web Mobile',
  TIZEN = 'Tizen',
  VIZIO = 'Vizio',
  ROKU = 'Roku',
  COMCAST = 'Comcast',
  XBOX = 'Xbox',
  PS4 = 'PlayStation 4',
  PS5 = 'PlayStation 5',
  VIDAA = 'Vidaa',
  PANASONIC = 'Panasonic',
  UNKNOWN = 'Unknown',
}
